import { Link } from "react-router-dom";

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center px-6 py-10">
      {/* Logo arriba */}
      <Link to="/" className="mb-10">
        <img src="/noltrade_gpt.png" alt="Noltrade" className="h-12" />
      </Link>

      <div className="max-w-3xl w-full text-sm text-gray-700 space-y-4">
        <h1 className="text-2xl font-bold mb-4">Aviso Legal</h1>

        <p>
          En cumplimiento con lo establecido en la Ley 34/2002, de 11 de julio, de servicios de la
          sociedad de la información y de comercio electrónico (LSSI-CE), se informa a los
          usuarios de que este sitio web es gestionado por:
        </p>

        <h2 className="font-semibold mt-6 mb-1">Titular del sitio web</h2>
        <p>
          <strong>Nombre completo:</strong> X<br />
          <strong>NIF:</strong>X<br />
          <strong>Domicilio fiscal:</strong> X<br />
          <strong>Email de contacto:</strong> contacto@noltrade.es
        </p>

        <p className="mt-4">
          <strong>Noltrade</strong> es una marca comercial gestionada por el titular arriba indicado.
        </p>

        <h2 className="font-semibold mt-6 mb-1">Objeto</h2>
        <p>
          El presente sitio web tiene por objeto facilitar a los usuarios información sobre
          oportunidades de compraventa de negocios digitales y facilitar el contacto entre partes
          interesadas mediante herramientas digitales.
        </p>

        <h2 className="font-semibold mt-6 mb-1">Condiciones de uso</h2>
        <p>
          El acceso y uso de este sitio web atribuye la condición de usuario y supone la aceptación
          plena de las condiciones aquí reflejadas. El titular se reserva el derecho de modificar
          en cualquier momento y sin previo aviso la presentación, configuración y contenidos del
          sitio web.
        </p>

        <h2 className="font-semibold mt-6 mb-1">Propiedad intelectual</h2>
        <p>
          Todos los contenidos del sitio web, incluyendo textos, imágenes, diseño gráfico, código y
          logotipos, son titularidad de Pau Nolasco Mestre o cuentan con licencia de uso, y están
          protegidos por la legislación vigente en materia de propiedad intelectual e industrial.
        </p>

        <h2 className="font-semibold mt-6 mb-1">Responsabilidad</h2>
        <p>
          El titular no se hace responsable del mal uso que los usuarios puedan hacer del sitio
          web ni de los contenidos accesibles a través de enlaces externos. Asimismo, no garantiza
          la disponibilidad continua del sitio, aunque se realizarán los esfuerzos razonables para
          asegurar su funcionamiento estable.
        </p>

        <h2 className="font-semibold mt-6 mb-1">Legislación aplicable</h2>
        <p>
          El presente aviso legal se rige íntegramente por la legislación española. Para la
          resolución de cualquier conflicto relacionado con el acceso o uso del sitio web, el
          usuario y el titular se someterán expresamente a los juzgados y tribunales del
          domicilio del titular, salvo que la normativa establezca otro fuero obligatorio.
        </p>

        <p className="text-xs text-gray-400 mt-6">Última actualización: mayo 2025</p>
      </div>
    </div>
  );
}
